import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import axios from 'axios'
import 'font-awesome/css/font-awesome.css';
//import * as VueGoogleMaps from 'vue2-google-maps';
window.$ = window.jQuery = require('jquery');
require("gmap3");


Vue.prototype.$axios = axios
Vue.prototype.$axios.defaults.withCredentials = true;
//axios interceptor
Vue.prototype.$axios.interceptors.response.use((response) => {

  console.log("requests " + response.status);
  if (response.status == 401) {
    window.location = '/';
  }

  return response;
},
  (error) => {
    console.log("user auth fail " + error.response.status);
    if (error.response.status == 401) {
      window.location = '/';
    }
    return Promise.reject(error);
  }

);



Vue.prototype.$hostServer = '';
//Vue.prototype.$hostServer = 'http://localhost:8081';



// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyDf43lPdwlF98RCBsJOFNKOkoEjkwxb5Sc',
//     //libraries: 'places', // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)

//     //// If you want to set the version, you can do so:
//     // v: '3.26',
//   },

//   //// If you intend to programmatically custom event listener code
//   //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
//   //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
//   //// you might need to turn this on.
//   // autobindAllEvents: false,

//   //// If you want to manually install components, e.g.
//   //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
//   //// Vue.component('GmapMarker', GmapMarker)
//   //// then disable the following:
//   // installComponents: true,
// });


Vue.use(Vuetify, {
  theme: {
    primary: '#03a9f4',
    secondary: '#00bcd4',
    accent: '#2196f3',
    error: '#f44336',
    warning: '#ff9800',
    info: '#ffeb3b',
    success: '#8bc34a'
  }
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
